import type { NewsDetail, NewsDetailData } from "@laftel-ip-originals/notion/contracts";
import { getNewsDetailPath } from "~/data/content-paths";
import { useStaticDetail } from "~/hooks/use-static-detail";

const OPTIONS = {
  buildPath: getNewsDetailPath,
  extract: (raw: NewsDetailData) => raw.item,
  errorMessage: "Failed to load news detail.",
};

export function useNewsDetail(slug: string | undefined, id: string | null) {
  return useStaticDetail<NewsDetailData, NewsDetail>(slug, id, OPTIONS);
}
